<script>
import { defineComponent } from 'vue';
import radio from "@/component/helper/form/radio.vue";
import ic_service from "@/assets/icons/ic_service.svg";
import icedit from "@/assets/icons/icedit.svg";
import ic_delete from "@/assets/icons/ic_delete.svg";
import modifsService from './modifsServicePopup.vue';
import deleteService from './deleteService.vue';

export default defineComponent({
  name: "ServiceLists",
  components: { radio, modifsService, deleteService },
  props: {
    oneService: {
      type: Object,
      default: () => ({}),
    }
  },
  emits: ['refresh'],
  data() {
    return {
      icons: { ic_service, icedit, ic_delete },
      deleteService: false,
      modifsService: false,
      isLoading: false,
      selectedService: null,
    };
  },
  methods: {
    refresh(){
      this.$emit('refresh');
    },
    truncateText(text, maxLength, suffix = '...') {
      return text && text.length > maxLength ? text.slice(0, maxLength) + suffix : text;
    },
    openModifsService(service) {
      this.selectedService = { ...service };
      this.modifsService = true;
      console.log(this.oneService.id)
    },
    closeCreate(updated) {
      if (updated) {
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
      this.modifsService = false;
    },
    closeDelete() {
      this.deleteService = false;
    },
  }
});
</script>

<template>
  <div class="ServiceLists">
    <div class="border-b BorderColor w-full flex items-center px-5 h-20 gap-2">
      <div class="flex justify-start items-center gap-5 w-1/2">
        <radio @click.stop />
        <div class="flex items-center gap-3">
          <icon
            :data="icons.ic_service"
            height="20"
            width="20"
            class="w-5 h-5"
            original
          />
          {{ truncateText(oneService.title, 50) }}
        </div>
      </div>
      <div class="w-1/2 flex justify-start">
        {{ oneService.description ? truncateText(oneService.description, 80) : '---' }}
      </div>
      <div class="w-1/4 Email responsive-large flex justify-start">
        {{ oneService.ownersEmail[0] }}
      </div>
      <div class="w-1/6 Email responsive-large flex justify-center">
        <div class="flex items-center gap-3">
          <icon
            :data="icons.icedit"
            height="40"
            width="40"
            class="cursor-pointer"
            original
            @click="openModifsService(oneService)"
          />
          <icon
            :data="icons.ic_delete"
            height="40"
            width="40"
            class="cursor-pointer"
            original
            @click="deleteService = true"
          />
        </div>
      </div>
    </div>
    
    <div v-if="modifsService">
      <modifsService
        :selected-service="selectedService"
        @closeCreate="closeCreate"
        :is-loading="isLoading"
        :serviceId="oneService.id"
        @refresh="refresh"
      />
    </div>

    <div v-if="deleteService">
      <deleteService
        @closeDelete="closeDelete"
        @serviceDeactivated="handleServiceDeactivated"
        :serviceId="oneService.id"
        :is-loading="isLoading"
        @refresh="refresh"
      />
    </div>
  </div>
</template>
